// collapseKeepLinks.tsx
import { EllipsisOutlined } from '@ant-design/icons';
import type { BreadcrumbProps } from 'antd';

type BuildOpts = { maxVisible?: number };

export default function buildCollapsedBreadcrumbItems(
  rawItems: BreadcrumbProps['items'] = [],
  { maxVisible = 4 }: BuildOpts = {},
): BreadcrumbProps['items'] {
  if (!rawItems?.length) return [];

  // 1) Rimuovo href/path dagli item VISIBILI, ma lascio invariato `title` (può essere <Link/>)
  const sanitize = (it: any, i: number) => {
    const { href, path, onClick, ...rest } = it || {};
    return { key: it?.key ?? `bc-${i}`, ...rest }; // nessun href/path -> niente <a> esterno
  };

  if (rawItems.length <= maxVisible) {
    return rawItems.map(sanitize);
  }

  // 2) Collasso: [first] [...] [last-1] [last]
  const keepTail = Math.max(2, maxVisible - 2);

  const firstVisible = sanitize(rawItems[0]!, 0);
  const tailVisible = rawItems
    .slice(rawItems.length - keepTail)
    .map((it, i) => sanitize(it, i + rawItems.length - keepTail));

  const middle = rawItems.slice(1, rawItems.length - keepTail); // per il menu manteniamo i title originali

  // 3) Ellissi con menu le cui voci sono i tuoi `title` originali (quindi <Link/> rimane)
  const ellipsis = {
    key: 'bc-ellipsis',
    title: <EllipsisOutlined />,
    menu: {
      // niente onClick qui: il `label` contiene già il tuo <Link/> -> SPA garantita
      items: middle.map((m, idx) => ({ key: `mid-${idx}`, label: m.title as any })),
    },
  } as const;

  return [firstVisible, ellipsis as any, ...tailVisible];
}
